import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";

const dropdownData = {
    "l0": [
        {
            "name": "GP Directs",
            "l1": [
                {
                    "name": "PACKAGING",
                    "l2": [
                        {
                            "name": "RESIN",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "High-Density And Low-Density Polyethylene (HDPE/LDPE) Resins",
                                "PET Resin With Intrinsic Viscosity ≤ 78 ml/g",
                                "PET Resin With Intrinsic Viscosity ≥ 78 ml/g",
                                "Polyethylene (PE) Resin In Primary Form",
                                "Polypropylene (PP) Resin In Primary Form",
                                "Recycled PET Materials (Flakes or Bottle Bales)"
                            ]
                        },
                        {
                            "name": "Others",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Folding Cartons, Boxes, and Cases of Non-Corrugated Paper or Paperboard"
                            ]
                        },
                        {
                            "name": "FILM",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Biaxially Oriented Polyethylene Terephthalate (BOPET) Film",
                                "Low-Density Polyethylene (LDPE) Shrink Wrap Film For Product Collation"
                            ]
                        },
                        {
                            "name": "PLASTIC BOTTLES/PRE-FORMS",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Articles Made from Polypropylene Polymers",
                                "Articles Reinforced Exclusively with Metal",
                                "Glass Containers – Carboys, Bottles, Flasks, and Similar Articles",
                                "Miscellaneous Plastic Articles of Polymers (Headings 3901–3914) – Other",
                                "Plastic Lids and Closures",
                                "Plastic Lids, Safe Rims, Stoppers, and Caps"
                            ]
                        },
                        {
                            "name": "CLOSURES",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "HDPE Closures Made From Ethylene Polymers (Non-Elastomeric) In Primary Form",
                                "PP Closures Made From Propylene Or Other Olefins In Primary Form"
                            ]
                        },
                        {
                            "name": "PAPERBOARD",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Cloth-Lined or Reinforced Paper Sheets",
                                "Multi-Ply Paper and Paperboard – General Use",
                                "Multi-Ply Paper and Paperboard – Reinforced or Laminated",
                                "Shaped Paper and Paperboard – Cut to Specific Forms",
                                "Uncoated Kraft Paper and Paperboard"
                            ]
                        },
                        {
                            "name": "CORRUGATED",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Corrugated Paper or Paperboard Cartons, Boxes, and Cases",
                                "Corrugated Paper Sheets"
                            ]
                        }
                    ]
                },
                {
                    "name": "SWEETENERS",
                    "l2": [
                        {
                            "name": "SUCROSE",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Molasses Derived From Sugar Refining",
                                "Pure Sugars (Lactose, Maltose, Glucose, Fructose) And Sugar Syrups Without Additives",
                                "Raw And Refined Cane Or Beet Sugar"
                            ]
                        }
                    ]
                },
                {
                    "name": "FRUITS & VEGETABLES",
                    "l2": [
                        {
                            "name": "Others",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Dehydrated Potato Flakes",
                                "Fresh Potatoes",
                                "Potatoes (excluding Frozen) – Prepared or Preserved",
                                "Refined Potato Starch"
                            ]
                        }
                    ]
                },
                {
                    "name": "INGREDIENTS",
                    "l2": [
                        {
                            "name": "Others",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Agricultural Seeds",
                                "Beverage Fragrance Mixtures – Odoriferous Substances",
                                "Cereal Flours (Excluding Wheat)",
                                "Chemical Mixtures – Other, Including Blends",
                                "Flavor Extracts, Essences, and Concentrates",
                                "Juices from Fruits, Nuts, or Vegetables – Including Coconut Water",
                                "Miscellaneous Food Preparations Not Elsewhere Specified",
                                "Preserved or Prepared Fruits, Nuts, and Edible Plant Parts",
                                "Processed Oats",
                                "Processed Oats - China",
                                "Sauces and Sauce Preparations",
                                "Tomato Ketchup and Other Tomato-Based Sauces"
                            ]
                        },
                        {
                            "name": "PROTEIN",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Dairy-Based Food Preparations"
                            ]
                        },
                        {
                            "name": "CHOCOLATE",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Ground Cocoa Bean Preparations – With or Without Cocoa Fat"
                            ]
                        },
                        {
                            "name": "NON FLAVOURS",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Ascorbic Acid (Vitamin C) and Derivatives – Natural or Synthetic, Unmixed",
                                "Caffeine and Its Chemical Salts",
                                "Coloring Agents of Animal or Vegetable Origin – NESOI",
                                "Gluconic Acid Salts and Esters",
                                "Lactic Acid Salts and Esters",
                                "Refined Salt and Pure Sodium Chloride",
                                "Vitamins and Provitamins – Including Natural Concentrates"
                            ]
                        }
                    ]
                },
                {
                    "name": "COMMODITIES",
                    "l2": [
                        {
                            "name": "EDIBLE OILS AND FATS",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Palm Kernel Oil",
                                "Palm Oil",
                                "Refined Canola Oil For Food Or Industrial Use",
                                "Sunflower Oil",
                                "Virgin Coconut Oil"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Co Man",
            "l1": [
                {
                    "name": "CRACKERS & CONFECTIONERY",
                    "l2": [
                        {
                            "name": "Others",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Confections and Sweetmeats – Ready for Consumption",
                                "Flavored and Sweetened Waters – Including Mineral and Aerated",
                                "Ready-to-Eat Foods from Unroasted Cereal Flakes or Mixtures",
                                "Special Dietary Biscuits",
                                "Sugar-Based Confectionery Products",
                                "Sweet Biscuits"
                            ]
                        }
                    ]
                },
                {
                    "name": "FOODS",
                    "l2": [
                        {
                            "name": "Others",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Baking Mixes and Doughs for Products of Heading 19.05",
                                "Puffed or Roasted Cereal-Based Snacks"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "GP Indirects",
            "l1": [
                {
                    "name": "MAINT, REPAIRS, OPS",
                    "l2": [
                        {
                            "name": "OPERATING SUPPLIES",
                            "hsCodes": [
                                "390110",
                                "390769",
                                "390761",
                                "390729",
                                "390230",
                                "390791",
								"0701"
                            ],
                            "productDescriptions": [
                                "Acid Dyes and Premetallized Dye Preparations",
                                "Commercial Silicates – Alkali Metal Variants",
                                "Fused and Sintered Magnesia (Dead-Burned), With or Without Additives",
                                "Glycosides and Derivatives – Natural or Synthesized",
                                "Miscellaneous Chemical Preparations – Not Elsewhere Specified",
                                "Nonaromatic Amino Acids (Excluding Glycine and Multifunctional Types)",
                                "Nonaromatic Heterocyclic Compounds – NESOI",
                                "Peptones, Protein Derivatives, and Chromed or Unchromed Hide Powder",
                                "Potassium Chloride – Industrial or Fertilizer Grade"
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "dateDetail": {
        "maxDate": "2025-03-01",
        "maxYearMonth": "Mar 2025",
        "minDate": "2023-01-01",
        "minYearMonth": "Jan 2023"
    },
    "defaultProductDescription": "Acid Dyes and Premetallized Dye Preparations",
    "defaultHSCode": "0701"
}

const FetchExImDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/exim-smart-cube/dropdown-api`,postData);
        var resData = Object.assign({ type: 'SUCCESS_EXIM_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};
const FetchExImSecondaryDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/exim-smart-cube/country-filter-api`,postData);
        var resData = Object.assign({ type: 'SUCCESS_EXIM_COUNTRY_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};


const FetchExImMonthlyReportAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/exim-smart-cube/monthly-report-kpi`,postData);
        var resData = Object.assign({ type: 'SUCCESS_EXIM_MONTHLY_REPORT_ACTION' }, data);
        dispatch(resData);
    };
};
const FetchExImCountryReportAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/exim-smart-cube/country-report-kpi`,postData);
        var resData = Object.assign({ type: 'SUCCESS_EXIM_COUNTRY_REPORT_ACTION' }, data);
        dispatch(resData);
    };
};
// const FetchImarcDetailAction = (postData) => {
//     return async function (dispatch) {
//         const data = await postApiCall(`${appConstants.BASE_URL}/imarc/kpi-page-data`,postData);
//         var resData = Object.assign({ type: 'SUCCESS_IMARC_DETAIL_ACTION' }, data);
//         dispatch(resData);
//     };
// };

export {
    FetchExImDropdownAction,
    FetchExImSecondaryDropdownAction,
    FetchExImMonthlyReportAction,
    FetchExImCountryReportAction
    // FetchImarcDetailAction
}